// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1T3i_","title":"ClientCherryInfo_title__1weT_","itemText":"ClientCherryInfo_itemText__KbQEH"};